$(document).ready(function(){

    $(".mobile-only-scroll-next").on('click', function() {
        var currentSection = $('.shopify-section.hero-video-sec');
        if (!currentSection.length) return;

        var allSections = $('.shopify-section');
        var currentIndex = allSections.index(currentSection);
        var nextSection = allSections.eq(currentIndex + 1);

        if (nextSection.length) {
            $('html, body').animate({
                scrollTop: nextSection.offset().top
            }, 600);
        }
    });

    $(".mobile-only-scroll-next-img").on('click', function() {
        var currentSection = $('.shopify-section.hero-img-sec');
        if (!currentSection.length) return;

        var allSections = $('.shopify-section');
        var currentIndex = allSections.index(currentSection);
        var nextSection = allSections.eq(currentIndex + 1);

        if (nextSection.length) {
            $('html, body').animate({
                scrollTop: nextSection.offset().top
            }, 600);
        }
    });

    // Toggle dropdown on button click
    $(".mobile_lang_selector").on("click", function(e) {
        e.stopPropagation();
        $(".mobile-lang-list").toggleClass("show_mobile-lang-list");
    });

    // Close dropdown when clicking outside
    $(document).on("click", function(e) {
        if (!$(e.target).closest(".mobile-lang-list, .mobile_lang_selector").length) {
            $(".mobile-lang-list").removeClass("show_mobile-lang-list");
        }
    });
    
    let isUpdating = false;

    $("div#CartDrawer form#CartDrawerForm").on("click", ".js-qty__adjust", function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        console.log("qty_plus_minus");

        if (isUpdating) return;

        const cartItem = $(this).closest('.cart__item');
        const depositFeeVariantId = cartItem.attr('data-deposit-fee-variant');

        if (depositFeeVariantId) {
            const qtyInput = cartItem.find('.js-qty__num');
            let newQuantity = parseInt(qtyInput.val(), 10);
            if (isNaN(newQuantity)) newQuantity = 0;

            if ($(this).hasClass('js-qty__adjust--minus')) {
                newQuantity = Math.max(newQuantity - 1, 0);
                console.log("newQuantity minus:", newQuantity);
            } else if ($(this).hasClass('js-qty__adjust--plus')) {
                newQuantity = newQuantity;
                console.log("newQuantity plus:", newQuantity);
            }

            console.log('New Quantity (button click):', newQuantity);
            qtyInput.val(newQuantity);

            isUpdating = true;
            updateMatchingItemsQuantity(depositFeeVariantId);
            isUpdating = false;
        }

        return false;
    });

    $("div#CartDrawer form#CartDrawerForm").on("keydown change input", ".js-qty__num", function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        console.log("qty_trigger");

        if (isUpdating) return;

        const cartItem = $(this).closest('.cart__item');
        const depositFeeVariantId = cartItem.attr('data-deposit-fee-variant');
        
        if (depositFeeVariantId) {
            let newQuantity = $(this).val();
            newQuantity = isNaN(newQuantity) ? 0 : Math.max(parseInt(newQuantity), 0);

            console.log('New Quantity (input event):', newQuantity);

            isUpdating = true;
            updateMatchingItemsQuantity(depositFeeVariantId);
            isUpdating = false;
        }

        return false;
    });

    // Function to update matching items' quantities
    function updateMatchingItemsQuantity(depositFeeVariantId) {
        const cartItems = document.querySelectorAll('.cart__item');
        let totalQuantity = 0;

        cartItems.forEach(item => {
            const itemDepositFeeVariantId = item.getAttribute('data-deposit-fee-variant');
            const qtyInput = item.querySelector('.js-qty__num');
            
            if (itemDepositFeeVariantId === depositFeeVariantId) {
                const quantity = parseInt(qtyInput.value, 10) || 0;
                totalQuantity += quantity;
            }
        });

        console.log("Total quantity for deposit-fee variant:", totalQuantity);

        // Now, find the "deposit-fee" item and update its quantity
        const depositFeeItem = Array.from(cartItems).find(item => {
            const itemUrl = item.querySelector('.cart__item--image a').getAttribute('href');
            return itemUrl && itemUrl.includes(`?variant=${depositFeeVariantId}`);
        });

        if (depositFeeItem) {
            const depositFeeQtyInput = depositFeeItem.querySelector('.js-qty__num');
            if (depositFeeQtyInput) {
                depositFeeQtyInput.value = totalQuantity;
                console.log(`Updated deposit fee item quantity to: ${totalQuantity}`);

                const depositFeeItemKey = depositFeeItem.getAttribute('data-key');
                console.log('Deposit Fee Item Key:', depositFeeItemKey);

                $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data: {
                        id: depositFeeItemKey,
                        quantity: totalQuantity
                    },
                    dataType: 'json',
                    success: function(cartResponse) {
                        console.log("Cart updated:", cartResponse);
                        openCartDrawerAndRefresh(function() {
                            console.log("Cart refreshed with updated quantities.");
                        });
                    },
                    error: function(err) {
                        console.error("Failed to update cart", err);
                    }
                });
            }
        } else {
            console.warn("Deposit fee item not found.");
        }
    }

    // Function to refresh the cart
    function openCartDrawerAndRefresh(callback) {
        const cartDrawer = document.querySelector('#CartDrawer');
        if (cartDrawer) {
            console.log('Refreshing CartDrawer...');
            // Fetch the updated cart data
            $.getJSON('/cart.js', function(cart) {
                console.log("Updated cart data:", cart);
                
                const productsContainer = cartDrawer.querySelector('[data-products]');
                
                if (productsContainer) {
                    const cartFormElement = cartDrawer.querySelector('#CartDrawerForm');
                    if (cartFormElement) {
                        const cartForm = new theme.CartForm(cartFormElement);
                        cartForm.buildCart();
                        console.log("CartDrawer updated with new products.");
                        if (typeof callback === 'function') {
                            callback();
                        }
                    }
                }
            }).fail(function(jqXHR, textStatus, errorThrown) {
                console.error("Failed to fetch cart data:", textStatus, errorThrown);
            });
        }
    }

    function initMobileSlider() {
      if ($(window).width() < 768) {
        if (!$('.mobile_slider').hasClass('slick-initialized')) {
          $('.mobile_slider').slick({
            slidesToShow: 1.2,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            prevArrow: '<div class="blog_post_prev blog_slick_arrow"><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.65871 9.29691L1.26406 17.2954C1.12399 17.4289 0.937896 17.5034 0.744379 17.5034C0.550863 17.5034 0.364773 17.4289 0.224705 17.2954L0.215666 17.2864C0.147528 17.2216 0.0932713 17.1437 0.0561953 17.0574C0.0191193 16.971 0 16.878 0 16.784C0 16.69 0.0191193 16.597 0.0561953 16.5107C0.0932713 16.4243 0.147528 16.3464 0.215666 16.2817L8.12077 8.75012L0.215666 1.2216C0.147528 1.15687 0.0932713 1.07895 0.0561953 0.992592C0.0191193 0.906229 0 0.813229 0 0.719246C0 0.625263 0.0191193 0.532263 0.0561953 0.4459C0.0932713 0.359539 0.147528 0.281624 0.215666 0.216892L0.224705 0.207853C0.364773 0.0743275 0.550863 -0.000160217 0.744379 -0.000160217C0.937896 -0.000160217 1.12399 0.0743275 1.26406 0.207853L9.65871 8.20635C9.73253 8.27669 9.79131 8.36129 9.83147 8.45502C9.87163 8.54875 9.89233 8.64966 9.89233 8.75163C9.89233 8.8536 9.87163 8.95451 9.83147 9.04824C9.79131 9.14197 9.73253 9.22657 9.65871 9.29691Z" fill="black"/></svg></div>',
            nextArrow: '<div class="blog_post_next blog_slick_arrow"><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.65871 9.29691L1.26406 17.2954C1.12399 17.4289 0.937896 17.5034 0.744379 17.5034C0.550863 17.5034 0.364773 17.4289 0.224705 17.2954L0.215666 17.2864C0.147528 17.2216 0.0932713 17.1437 0.0561953 17.0574C0.0191193 16.971 0 16.878 0 16.784C0 16.69 0.0191193 16.597 0.0561953 16.5107C0.0932713 16.4243 0.147528 16.3464 0.215666 16.2817L8.12077 8.75012L0.215666 1.2216C0.147528 1.15687 0.0932713 1.07895 0.0561953 0.992592C0.0191193 0.906229 0 0.813229 0 0.719246C0 0.625263 0.0191193 0.532263 0.0561953 0.4459C0.0932713 0.359539 0.147528 0.281624 0.215666 0.216892L0.224705 0.207853C0.364773 0.0743275 0.550863 -0.000160217 0.744379 -0.000160217C0.937896 -0.000160217 1.12399 0.0743275 1.26406 0.207853L9.65871 8.20635C9.73253 8.27669 9.79131 8.36129 9.83147 8.45502C9.87163 8.54875 9.89233 8.64966 9.89233 8.75163C9.89233 8.8536 9.87163 8.95451 9.83147 9.04824C9.79131 9.14197 9.73253 9.22657 9.65871 9.29691Z" fill="black"/></svg></div>',
            infinite: false,
            adaptiveHeight: true,
          });
        }
      } else {
        if ($('.mobile_slider').hasClass('slick-initialized')) {
          $('.mobile_slider').slick('unslick');
        }
      }
    }

    // Run on load and on resize
    initMobileSlider();
    $(window).on('resize', function () {
        initMobileSlider();
    });

    $('.quantity-wrapper').each(function() {
        const wrapper = $(this);
        const input = wrapper.find('.qty-input');

        wrapper.find('.plus').click(function() {
            let val = parseInt(input.val()) || 0;
            input.val(val + 1).trigger('change');
        });

        wrapper.find('.minus').click(function() {
            let val = parseInt(input.val()) || 0;
            const min = parseInt(input.attr('min')) || 1;
            if (val > min) {
                input.val(val - 1).trigger('change');
            }
        });
    });

    function isMobile() {
        return $(window).width() <= 768;
    }

    function toggleHeaderClass() {
        if (isMobile()) {
            if ($(window).scrollTop() > 250) {
                $('div.header-wrapper').addClass('sticky-header-wrapper');
                $('header').addClass('sticky-site-header');
            } else {
                $('div.header-wrapper').removeClass('sticky-header-wrapper');
                $('header').removeClass('sticky-site-header');
            }
        }
    }

    $(window).on('scroll', function() {
        toggleHeaderClass();
    });

    toggleHeaderClass();

    // announcement slider
    $(".announcements-list-slider").slick({
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1500,
        speed: 800,
        adaptiveHeight: false,
        fade: true,
        cssEase: "linear",
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    arrows: true,
                    prevArrow: '<div class="announcement-arrow ann-prev"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_139_19)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90625L12.0125 0.950001C12.2188 0.743751 12.2188 0.406251 12.0125 0.200001C11.8063 -0.00624943 11.4688 -0.00624943 11.2625 0.200001L3.92814 7.53125C3.72189 7.7375 3.72189 8.075 3.92814 8.28125L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="white"/></g><defs><clipPath id="clip0_139_19"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
                    nextArrow: '<div class="announcement-arrow ann-next"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_139_21)"><path d="M4.25936 15.8719C4.12498 15.8719 3.98747 15.8188 3.88434 15.7156C3.67809 15.5094 3.67809 15.1719 3.88434 14.9656L10.9437 7.90625L3.98747 0.950001C3.78122 0.743751 3.78122 0.406251 3.98747 0.200001C4.19372 -0.00624943 4.53122 -0.00624943 4.73747 0.200001L12.0718 7.53125C12.2781 7.7375 12.2781 8.075 12.0718 8.28125L4.63747 15.7156C4.53122 15.8219 4.39686 15.8719 4.25936 15.8719Z" fill="white"/></g><defs><clipPath id="clip0_139_21"><rect width="16" height="16" fill="white" transform="matrix(0 -1 -1 0 16 16)"/></clipPath></defs></svg></div>',
                    fade: false,
                    cssEase: "ease",
                }
            }
        ]
    });

    // related products
    $('.related-products-list-slider').slick({
        dots: false,
        arrows: true,
        nextArrow: '<div class="next_arrow_slick"><svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3137 10.6181L1.9359 19.5534C1.77943 19.7026 1.57154 19.7858 1.35536 19.7858C1.13918 19.7858 0.931298 19.7026 0.774825 19.5534L0.764728 19.5433C0.688609 19.471 0.627998 19.3839 0.58658 19.2875C0.545162 19.191 0.523804 19.0871 0.523804 18.9821C0.523804 18.8771 0.545162 18.7732 0.58658 18.6767C0.627998 18.5803 0.688609 18.4932 0.764728 18.4209L9.59566 10.0073L0.764728 1.59706C0.688609 1.52474 0.627998 1.4377 0.58658 1.34123C0.545162 1.24475 0.523804 1.14086 0.523804 1.03587C0.523804 0.930878 0.545162 0.826986 0.58658 0.730511C0.627998 0.634035 0.688609 0.546993 0.764728 0.47468L0.774825 0.464584C0.931298 0.315418 1.13918 0.232206 1.35536 0.232206C1.57154 0.232206 1.77943 0.315418 1.9359 0.464584L11.3137 9.39984C11.3962 9.47842 11.4618 9.57293 11.5067 9.67764C11.5516 9.78234 11.5747 9.89507 11.5747 10.009C11.5747 10.1229 11.5516 10.2356 11.5067 10.3403C11.4618 10.445 11.3962 10.5396 11.3137 10.6181Z" fill="#B2B2B2"/></svg></div>',
        prevArrow: '<div class="prev_arrow_slick"><svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.680913 10.6181L10.0587 19.5534C10.2152 19.7026 10.4231 19.7858 10.6393 19.7858C10.8554 19.7858 11.0633 19.7026 11.2198 19.5534L11.2299 19.5433C11.306 19.471 11.3666 19.3839 11.408 19.2875C11.4495 19.191 11.4708 19.0871 11.4708 18.9821C11.4708 18.8771 11.4495 18.7732 11.408 18.6767C11.3666 18.5803 11.306 18.4932 11.2299 18.4209L2.39897 10.0073L11.2299 1.59706C11.306 1.52474 11.3666 1.4377 11.408 1.34123C11.4495 1.24475 11.4708 1.14086 11.4708 1.03587C11.4708 0.930878 11.4495 0.826986 11.408 0.730511C11.3666 0.634035 11.306 0.546993 11.2299 0.47468L11.2198 0.464584C11.0633 0.315418 10.8554 0.232206 10.6393 0.232206C10.4231 0.232206 10.2152 0.315418 10.0587 0.464584L0.680913 9.39984C0.598439 9.47842 0.53278 9.57293 0.487918 9.67764C0.443055 9.78234 0.419922 9.89507 0.419922 10.009C0.419922 10.1229 0.443055 10.2356 0.487918 10.3403C0.53278 10.445 0.598439 10.5396 0.680913 10.6181Z" fill="#B2B2B2"/></svg></div>',
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    });

    // testimonial slider
    $(".testimonial-list-slider").slick({
        dots: true,
        arrows: true,
        infinite: false,
        adaptiveHeight: true,
        nextArrow: '<div class="next_arrow_slick"><svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3137 10.6181L1.9359 19.5534C1.77943 19.7026 1.57154 19.7858 1.35536 19.7858C1.13918 19.7858 0.931298 19.7026 0.774825 19.5534L0.764728 19.5433C0.688609 19.471 0.627998 19.3839 0.58658 19.2875C0.545162 19.191 0.523804 19.0871 0.523804 18.9821C0.523804 18.8771 0.545162 18.7732 0.58658 18.6767C0.627998 18.5803 0.688609 18.4932 0.764728 18.4209L9.59566 10.0073L0.764728 1.59706C0.688609 1.52474 0.627998 1.4377 0.58658 1.34123C0.545162 1.24475 0.523804 1.14086 0.523804 1.03587C0.523804 0.930878 0.545162 0.826986 0.58658 0.730511C0.627998 0.634035 0.688609 0.546993 0.764728 0.47468L0.774825 0.464584C0.931298 0.315418 1.13918 0.232206 1.35536 0.232206C1.57154 0.232206 1.77943 0.315418 1.9359 0.464584L11.3137 9.39984C11.3962 9.47842 11.4618 9.57293 11.5067 9.67764C11.5516 9.78234 11.5747 9.89507 11.5747 10.009C11.5747 10.1229 11.5516 10.2356 11.5067 10.3403C11.4618 10.445 11.3962 10.5396 11.3137 10.6181Z" fill="#B2B2B2"/></svg></div>',
        prevArrow: '<div class="prev_arrow_slick"><svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.680913 10.6181L10.0587 19.5534C10.2152 19.7026 10.4231 19.7858 10.6393 19.7858C10.8554 19.7858 11.0633 19.7026 11.2198 19.5534L11.2299 19.5433C11.306 19.471 11.3666 19.3839 11.408 19.2875C11.4495 19.191 11.4708 19.0871 11.4708 18.9821C11.4708 18.8771 11.4495 18.7732 11.408 18.6767C11.3666 18.5803 11.306 18.4932 11.2299 18.4209L2.39897 10.0073L11.2299 1.59706C11.306 1.52474 11.3666 1.4377 11.408 1.34123C11.4495 1.24475 11.4708 1.14086 11.4708 1.03587C11.4708 0.930878 11.4495 0.826986 11.408 0.730511C11.3666 0.634035 11.306 0.546993 11.2299 0.47468L11.2198 0.464584C11.0633 0.315418 10.8554 0.232206 10.6393 0.232206C10.4231 0.232206 10.2152 0.315418 10.0587 0.464584L0.680913 9.39984C0.598439 9.47842 0.53278 9.57293 0.487918 9.67764C0.443055 9.78234 0.419922 9.89507 0.419922 10.009C0.419922 10.1229 0.443055 10.2356 0.487918 10.3403C0.53278 10.445 0.598439 10.5396 0.680913 10.6181Z" fill="#B2B2B2"/></svg></div>',
        speed: 600,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    function initCollectionFilterToggle() {
        // Remove any previous event handlers (namespaced for safety)
        $(document).off('click.collectionFilterToggle');

        // Add click handler (delegated so it works after Shopify AJAX reload)
        $(document).on('click.collectionFilterToggle', '.collection-filter__title', function () {
            var $group = $(this).closest('.collection-filter__group');
            var isActive = $group.hasClass('active__group');
            var $content = $(this).next();

            // Close all other groups’ inner content
            $('.collection-filter__group').each(function () {
            if (!$(this).is($group)) {
                    $(this).removeClass('active__group')
                    .find('.collection-filter__title')
                    .next().slideUp(250);
                }
            });

            // Toggle the clicked one
            if (isActive) {
                $group.removeClass('active__group');
                $content.slideUp(250);
            } else {
                $group.addClass('active__group');
                $content.slideDown(250);
            }
        });

        // Optionally open the first group on page load
        $('.collection-filter__group').first()
            .addClass('active__group')
            .find('.collection-filter__title')
            .next().show();
        }

        /* -------------------------------------
        INITIAL LOAD
        ------------------------------------- */
        $(document).ready(function () {
            initCollectionFilterToggle();
        });

        /* -------------------------------------
        RE-RUN WHEN SHOPIFY RELOADS FILTERS
        ------------------------------------- */
        document.addEventListener('shopify:section:load', function (event) {
        // Only run when the filters section reloads
        if (event.target.id === 'CollectionFiltersSection') {
            if ($('#CollectionFiltersSection').find('.tag-list--active-tags').length) {
                initCollectionFilterToggle();
            }
        }
    });

        /* -------------------------------------
        RE-RUN WHEN SHOPIFY UPDATES FILTERS (Dawn 8+)
        ------------------------------------- */
        document.addEventListener('shopify:filter:update', function () {
        if ($('#CollectionFiltersSection').find('.tag-list--active-tags').length) {
            initCollectionFilterToggle();
        }
    });

});